












































import { Component, Prop, Vue, Watch } from "vue-property-decorator";

import {
    renderComponents,
    renderSufix
} from "@/components/posts/RenderPostTypeRegister";

import { RenderChannelModel } from "@/services/render/types";
import { menuStyleCSS } from "@/services/styles/types";
import { setNextItem } from "../posts/types";
import { InteractionTypes } from "@/services/channels/types";

@Component({
    components: {
        ...renderComponents
    },
    filters: {
        render(value: string) {
            return value.concat(renderSufix);
        }
    }
})
export default class MenuRender extends Vue {
    @Prop() private menuRenderModel!: RenderChannelModel;
    @Prop() private dateTime!: Date;
    @Prop() interactionType!: InteractionTypes;

    currentItemId = "" as string;
    index = 0 as number;
    renderingModel = {} as RenderChannelModel;

    returnToFirstPostTimeout: any;
    isChannelgroup = false;
    buttonList: any = [];
    currentChannelId: string = "";
    width = 0;
    height = 0;
    update = false;
    menuStyleCSS = {
        content: "",
        menu: "",
        menuButton: "",
        active: "",
        backBtn: "",
        backBtnArrow: ""
    } as menuStyleCSS;

    extraCSS = "";
    allowRender = false;
    backButtonText = "";

    activeInteger = 1;
    calculateActive(itemId: string) {
        return (this.currentItemId === itemId) ? this.activeInteger : 0;
    }

    @Watch("menuRenderModel", { deep: true }) t() {
        if (JSON.stringify(this.renderingModel) !== JSON.stringify(this.menuRenderModel)) {
            this.renderMenu();
        }
    }

    // Computed
    get dynamicStyle() {
        return {
            height: `${this.menuRenderModel.height}px`,
            width: `${this.menuRenderModel.width}px`,
            "--duration": this.renderingModel.transitionTime / 1000 + "s",
            "--channelWidth": `${this.menuRenderModel.width}px`,
            "--channelWidthNegative": `-${this.menuRenderModel.width}px`,
            "--channelHeight": `${this.menuRenderModel.height}px`,
            "--channelHeightNegative": `-${this.menuRenderModel.height}px`
        };
    }

    get filteredPosts() {
        return this.renderingModel.renderPosts.filter(x => x.channelId === this.currentChannelId);
    }

    // Lifecycle hooks
    created() {
        this.renderMenu();
    }

    renderMenu() {
        if (this.menuRenderModel.renderPosts.length > 0) {
            this.allowRender = true;
            let toUpdate = false;
            if (JSON.stringify(this.renderingModel.menuCSS) !== JSON.stringify(this.menuRenderModel.menuCSS)) toUpdate = true;
            this.renderingModel = JSON.parse(JSON.stringify(this.menuRenderModel));

            // By default, the sidebar is 30% width, so the content must be 70%.
            this.width = Math.ceil(this.renderingModel.width * 0.70);
            this.height = this.renderingModel.height;
            this.extraCSS = `width: ${this.width}px; height: ${this.height}px;`;

            // If there are no null channelId's, it means it is a channel group.
            // Also, if it is menuFlat, this check won't pass and we render it like we would channels (flat).
            if (this.renderingModel.renderPosts.filter(x => x.channelId === null).length < 1 && this.interactionType !== InteractionTypes.menuFlat) {
                if (this.renderingModel.showFirstPost) this.showPost();

                this.isChannelgroup = true;
                const unique: any = [];
                this.buttonList = [];
                this.renderingModel.renderPosts.forEach(x => {
                    if (!unique.includes(x.channelId)) {
                        unique.push(x.channelId);
                        this.buttonList.push([x.channelId, x.channelName]);
                    }
                });
            }

            // Only start with showing a post if it is a channel and not a channel group
            if (!this.isChannelgroup && this.currentItemId === "") this.showPost();
            if (!this.isChannelgroup && this.renderingModel.renderPosts.filter(x => x.id === this.currentItemId).length === 0) this.returnToFirstPost();
            if (this.isChannelgroup && this.filteredPosts.filter(x => x.id === this.currentItemId).length === 0) this.returnToFirstPost();

            // If the user has specified a width or height, we need to discard the defaults and implemenet these instead.
            // If a percentage was used, convert it to pixels.
            if (this.renderingModel.menuCSS !== null) {
                this.menuStyleCSS = this.renderingModel.menuCSS;

                // Place the css on a dummy element so we have access to the styles programmatically rather than through a string.
                const dummy = document.createElement("div");
                dummy.style.cssText = this.menuStyleCSS.content;

                if (dummy.style.width !== null && dummy.style.height !== null) {
                    if (dummy.style.width !== "") {
                        if (dummy.style.width.includes("%")) this.width = Math.round((this.renderingModel.width / 100) * parseInt(dummy.style.width));
                        else this.width = parseInt(dummy.style.width);
                    }

                    if (dummy.style.height !== "") {
                        if (dummy.style.height.includes("%")) this.height = Math.round((this.renderingModel.height / 100) * parseInt(dummy.style.height));
                        else this.height = parseInt(dummy.style.height);
                    }
                }
            } else {
                this.menuStyleCSS = {
                    content: "",
                    menu: "",
                    menuButton: "",
                    active: "",
                    backBtn: "",
                    backBtnArrow: ""
                } as menuStyleCSS;
            }
            if (toUpdate) this.update = !this.update;
        } else {
            this.allowRender = false;
        }
    }

    destroyed() {
        clearTimeout(this.returnToFirstPostTimeout);
    }

    // Functions
    showPost(id: string = "") {
        if (id !== "") this.$emit("buttonClicked");
        clearTimeout(this.returnToFirstPostTimeout);
        if (this.renderingModel.renderPosts.length > 0) {
            this.currentItemId = id;
            if (id === "") {
                if (!this.isChannelgroup) this.currentItemId = this.renderingModel.renderPosts[0].id;
                else this.currentItemId = this.filteredPosts[0].id;
            }
        } else {
            this.currentItemId = "";
        }
        this.activeInteger++;
    }

    switchChannel(id: string) {
        this.$emit("buttonClicked");
        this.currentChannelId = id;
        this.backButtonText = this.renderingModel.renderPosts.filter(x => x.channelId === id)[0].channelName || "";
    }

    returnToFirstPostTimer() {
        if (this.renderingModel.renderPosts.length > 0) {
            clearTimeout(this.returnToFirstPostTimeout);
            this.returnToFirstPostTimeout = setTimeout(this.returnToFirstPost, this.renderingModel.returnToFirstPostTime * 1000);
        }
    }

    returnToFirstPost() {
        if (this.isChannelgroup && this.currentChannelId === "") return;
        if (this.isChannelgroup && this.currentItemId === this.filteredPosts[0].id) return;
        if (this.currentItemId !== this.renderingModel.renderPosts[0].id) this.showPost("");
    }

    setNextItem(data: setNextItem) {
        if (data.id === this.currentItemId) {
            if (this.isChannelgroup && this.currentChannelId === "") return;
            if (this.isChannelgroup && this.currentItemId === this.filteredPosts[0].id) return;
            if (this.currentItemId !== this.renderingModel.renderPosts[0].id) this.returnToFirstPostTimer();
        }
    }
}
